import React from "react";
import { PropertyDetails } from "../shared-components/ViewFragments/PropertyDetails/web";
import { PropertyDetailsPrint } from "../shared-components/ViewFragments/PropertyDetailsPrint/web";
import { decodeHashUrl } from "../shared-components/Utils/Functions";
import { useRouter } from "next/router";
import { withApollo } from "../lib/apollo3";
import { withAuth } from "../lib/auth";
import { withContext } from "../lib/context";
import { withGlobalComponents } from "../shared-components/ViewFragments/GlobalComponents/web";
import { withTranslation } from "../shared-components/i18n";
import AdvertiserProvider from "src/contexts/AdvertiserContext";
import { fetchSearchResults } from "src/services/search";
import { PropertyDataProvider } from "src/contexts/PropertyData/PropertyDataProvider";
import { redirect } from "next/dist/next-server/server/api-utils";
import { ContactModalProvider } from "shared-components/Contexts/ContactModal/context";
import { QUERY_PROPERTY_DETAILS } from "shared-components/GQL";
import { PropertyEmptyState } from "shared-components/Components/Property/EmptyState/web";

const propSingle = ({ __PROPERTY__ID__, data: propertyData, technicalSheeta, inactiveSimilarInfo, showEmptyState }) => {
	const { asPath } = useRouter();
	const isPrint = asPath.includes("imprimir");

	if (showEmptyState) {
		return <PropertyEmptyState data={propertyData}/>;
	}

	return (
		<PropertyDataProvider initialListing={propertyData}>
			<ContactModalProvider>
				<AdvertiserProvider>
					{isPrint ? (
						<PropertyDetailsPrint id={__PROPERTY__ID__} mode="property" />
					) : (
						<PropertyDetails
							id={__PROPERTY__ID__}
							mode="property"
							data={propertyData}
						/>
					)}
					{/* <RTBhouse page={"offer"} data={__PROPERTY__ID__} /> */}
				</AdvertiserProvider>
			</ContactModalProvider>
		</PropertyDataProvider>
	);
};

propSingle.getInitialProps = async function({ apolloClient, req, res, query }) {
	let property = await decodeHashUrl(query.hashed);
	const { main_domain } = property.configs;
	const __PROPERTY__ID__ = property.id;
	const payload = {
		rows: 1,
		params: {
			id: __PROPERTY__ID__,
		},
		page: 1,
		source: 10,
	};

	const fetchResult = await fetchSearchResults(payload, main_domain)
	const data = fetchResult?.searchFast?.data[0];
	
	let technicalSheet = null;

	if (!data) {
		
		if (res) {
			let  inactiveSimilarInfo = { 
				status: property.status,
				operation_type_id: property.operation_type_id,
				property_type_id: property.property_type_id,
				price: property.price,
				neighborhood_id: property.neighborhood_id,
				city_id: property.city_id
			}
			let showEmptyState = false;

			try {
				const { data: gqlData } = await apolloClient.query({
					query: QUERY_PROPERTY_DETAILS,
					variables: { id: __PROPERTY__ID__ },
				});
				
				const gqlProperty = gqlData?.property;
				
				let gqlPropertyData = {
					...gqlProperty,
					title: gqlProperty?.title + " [No disponible]",
                    inactiveSimilarInfo 
				};

				
				if (!gqlProperty?.owner?.active) {
					throw new Error('owner desactivate');
				}

				if (gqlProperty?.active && !gqlProperty?.deleted) {
					res.statusCode = 202;
					showEmptyState = true;
				} 
				
				return {
					__PROPERTY__ID__,
					data: gqlPropertyData,
					showEmptyState,
					technicalSheet: null,
					inactiveSimilarInfo
				};

			} catch (e) {
				res.statusCode = 404;
			}

			return {
				__PROPERTY__ID__,
				data: null,
				showEmptyState,
				technicalSheet: null,
				inactiveSimilarInfo
			};
		} else {
			throw new Error("Data not found");
		}
	} else {
		if (property.configs.country_code === "ce3") {
			const technicalSheetCeee = [...data.technicalSheet];
			const minimumStay =
				data.seasons && !!data.seasons.length
					? `${data.seasons[0].rental_data.minimum_stay} ${
							data.seasons[0].rental_data.minimum_stay !== 1 ? "días" : "día"
					  }`
					: null;

			technicalSheetCeee.push(
				{
					field: "guests",
					text: "Huéspedes",
					value: data.guests ? data.guests.toString() : null,
				},
				{
					field: "seaview",
					text: "Vista al mar",
					value: data.seaview ? "Sí" : "No",
				},
				{
					field: "minimum_stay",
					text: "Estadía mínima",
					value: minimumStay,
				}
			);

			const filtered = technicalSheetCeee.filter(
				technical => technical.field !== "disposition_name"
			);

			technicalSheet = filtered;
		} else {
			technicalSheet = data.technicalSheet;
		}
	}

	if (data?.project?.link) {
		redirect(res, `/proyectos/p/${data.project.id}`);
	}

	if(property.status === "deactivated") {
		data.active = false;
		data.inactiveSimilarInfo = {
			status: property.status,
			operation_type_id: property.operation_type_id,
			property_type_id: property.property_type_id,
			price: property.price,
			neighborhood_id: property.neighborhood_id,
			city_id: property.city_id
		}
	}

	return {
		__PROPERTY__ID__,
		data,
		technicalSheet,
		ConfigContextInitialState: property?.configs,
	};
};

export default withApollo(
	withContext(withTranslation(withAuth(withGlobalComponents(propSingle))), {
		withDummyContext: false,
		withFiltersContext: true,
		withConfigContext: true,
		withThemeContext: true,
	})
);

